import React from 'react';

export default () => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={22} height={22} rx={11} fill="#F0F2F5" />
    <path
      d="M6.625 9.125H7.875"
      stroke="#141414"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.375 9.125H11.625"
      stroke="#141414"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.125 9.125H15.375"
      stroke="#141414"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.625 15.375L6.625 6.625C6.625 6.29348 6.7567 5.97554 6.99112 5.74112C7.22554 5.5067 7.54348 5.375 7.875 5.375H9.75C9.75 5.70652 9.8817 6.02446 10.1161 6.25888C10.3505 6.4933 10.6685 6.625 11 6.625C11.3315 6.625 11.6495 6.4933 11.8839 6.25888C12.1183 6.02446 12.25 5.70652 12.25 5.375H14.125C14.4565 5.375 14.7745 5.5067 15.0089 5.74112C15.2433 5.97554 15.375 6.29348 15.375 6.625V15.375C15.375 15.7065 15.2433 16.0245 15.0089 16.2589C14.7745 16.4933 14.4565 16.625 14.125 16.625H12.25C12.25 16.2935 12.1183 15.9755 11.8839 15.7411C11.6495 15.5067 11.3315 15.375 11 15.375C10.6685 15.375 10.3505 15.5067 10.1161 15.7411C9.8817 15.9755 9.75 16.2935 9.75 16.625H7.875C7.54348 16.625 7.22554 16.4933 6.99112 16.2589C6.7567 16.0245 6.625 15.7065 6.625 15.375Z"
      stroke="#141414"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
